import { createVNode as t, mergeProps as i } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FolderFilled.js";
import m from "../components/PfIcon.js";
const r = (e, o) => {
  const l = {
    ...e,
    ...o.attrs
  };
  return t(m, i(l, {
    icon: d
  }), null);
};
r.displayName = "FolderFilled";
r.inheritAttrs = !1;
export {
  r as default
};
